import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Head from "next/head";
import Image from "next/image";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import axios from "axios";
import DataChart from "../../../component/chart/chart";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import Link from "next/link";
import Grid from "@mui/material/Grid";
import AgentCard from "../../../component/agentCard";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Custom404 from "../../404";
import { Card } from "@mui/material";
import CallToAction from "../../../component/callToAction";
import CallToActioTwo from "../../../component/callToActionTwo";
import GoogleMaps from "../../../component/googleSuburbMap";
import BarChart from "../../../component/barChart";
import home from "../../../styles/Home.module.css";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import abode from "../../../images/abodefinder.png";
import { useCookies } from "react-cookie";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Footer from "../../../component/footer";
import SuburbChart from "../../../component/suburbChart";

const Item = styled(Paper)(({ theme }) => ({
  lineHeight: "60px",
  borderRadius: "10px",
}));

// const SubmitBtn = styled(Button)(({ theme }) => ({
//   color: "#fff",
//   border: "1px solid var(--primary-color)",
//   fontWeight: "600",
//   width: "180px",
//   height: "45px",
//   fontSize: "15px",
//   backgroundColor: "var(--primary-color)",
//   padding: "3px",
//   "&:hover": {
//     border: "1px solid var(--dark-color)",
//     backgroundColor: "var(--dark-color)",
//   },
// }));

const SelectButton = styled(Link)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "100%",
  height: "45px",
  fontSize: "16px",
  backgroundColor: "var(--primary-color)",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  marginTop: "15px",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

const RegisterButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "45px",
  fontSize: "15px",
  marginRight: "10px",
  backgroundColor: "var(--primary-color)",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--primary-color)",
    color: "var(--dark-color)",
  },
}));

const DismisButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid #fff",
  fontWeight: "600",
  width: "180px",
  height: "45px",
  fontSize: "15px",
  "&:hover": {
    border: "1px solid var(--primary-color)",
    backgroundColor: "#01907d23",
    color: "var(--primary-color)",
  },
}));

export default function SuburbProfile({
  data,
  loading,
  suburb_name,
  description,
  canonical,
  registerFlag,
  limitFlag,
  houseData,
  unitData,
  transportation,
  school,
  income,
  language,
  houseHistory,
  unitHistory,
  stateName,
  access_token,
  login,
}) {
  const router = useRouter();
  const { state, suburb } = router.query;
  const [postcodeId, setPostCOdeId] = React.useState(null);
  const [agents, setAgents] = React.useState([]);
  const [dataFlag, setDataFlag] = React.useState(true);
  const [open, setOpen] = React.useState(true);
  const scroll = React.useRef(null);

  const [cookies, setCookie, removeCookie] = useCookies([
    "suburbAddress",
    "login",
    "access_token",
    "initialPath",
  ]);

  const [openDialog, setOpenDialog] = React.useState(true);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const registerRedirect = () => {
    router.push("/register/");
    setCookie("suburbAddress", window.location.pathname, { maxAge: 1800 });
  };

  const loginRedirect = () => {
    router.push("/login/");
    setCookie("suburbAddress", window.location.pathname, { maxAge: 1800 });
  };

  const [bookNow, setBookNow] = React.useState(false);

  let alertBox;
  const handleOpenBook = () => {
    setOpenDialog(false);
    setBookNow(true);
    alertBox = setInterval(() => {
      setBookNow(false);
      clearInterval(alertBox);
    }, 8000);
    axios.post(
      "https://abodefinder.com.au/api/new-lead/",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.access_token}`,
        },
      }
    );
  };

  const handleCloseBook = () => {
    setBookNow(false);
  };

  function createData(name, income) {
    return { name, income };
  }

  useEffect(() => {
    if (cookies.access_token && !localStorage.getItem("suburb_reloaded")) {
      localStorage.setItem("suburb_reloaded", true);
      window.location.reload();
    }
  }, [cookies.access_token]);

  let rows;
  if (income != null) {
    if (Object.keys(income).length == 0) {
      rows = [
        createData("Negative income", "No data"),
        createData("Nil income", "No data"),
        createData("$1-$149 ($1-$7,799)", "No data"),
        createData("$150-$299 ($7,800-$15,599)", "No data"),
        createData("$300-$399 ($15,600-$20,799)", "No data"),
        createData("$400-$499 ($20,800-$25,999)", "No data"),
        createData("$500-$649 ($26,000-$33,799)", "No data"),
        createData("$650-$799 ($33,800-$41,599)", "No data"),
        createData("$800-$999 ($41,600-$51,999)", "No data"),
        createData("$1,000-$1,249 ($52,000-$46,999)", "No data"),
        createData("$1,250-$1,499 ($65,000-$77,999)", "No data"),
        createData("$1,500-$1,749 ($78,000-$90,999)", "No data"),
        createData("$1,750-$1,999 ($91,000-$103,999)", "No data"),
        createData("$2,000-$2,999 ($104,000-$155,999)", "No data"),
        createData("$3,000 or more ($156,000 or more)", "No data"),
        createData("Not stated", "No data"),
        createData("Not applicable", "No data"),
      ];
    } else {
      rows = [
        createData(
          "Negative income",
          (Math.round(income.negative_income * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "Nil income",
          (Math.round(income.nil_income * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$1-$149 ($1-$7,799)",
          (Math.round(income.data1 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$150-$299 ($7,800-$15,599)",
          (Math.round(income.data2 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$300-$399 ($15,600-$20,799)",
          (Math.round(income.data3 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$400-$499 ($20,800-$25,999)",
          (Math.round(income.data4 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$500-$649 ($26,000-$33,799)",
          (Math.round(income.data5 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$650-$799 ($33,800-$41,599)",
          (Math.round(income.data6 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$800-$999 ($41,600-$51,999)",
          (Math.round(income.data7 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$1,000-$1,249 ($52,000-$46,999)",
          (Math.round(income.data8 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$1,250-$1,499 ($65,000-$77,999)",
          (Math.round(income.data9 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$1,500-$1,749 ($78,000-$90,999)",
          (Math.round(income.data10 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$1,750-$1,999 ($91,000-$103,999)",
          (Math.round(income.data11 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$2,000-$2,999 ($104,000-$155,999)",
          (Math.round(income.data12 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "$3,000 or more ($156,000 or more)",
          (Math.round(income.data13 * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "Not stated",
          (Math.round(income.not_stated * 100) / 100).toFixed(2) + "%"
        ),
        createData(
          "Not applicable",
          (Math.round(income.not_applicable * 100) / 100).toFixed(2) + "%"
        ),
      ];
    }
  }

  function createDataLanguage(name, language) {
    return { name, language };
  }

  let rowsLanguage;
  if (language != null) {
    if (Object.keys(language).length == 0) {
      rowsLanguage = [
        createDataLanguage("Northern European Languages", "No data"),
        createDataLanguage("Southern European Languages", "No data"),
        createDataLanguage("Eastern European Languages", "No data"),
        createDataLanguage("Southwest and Central Asian Languages", "No data"),
        createDataLanguage("Southern Asian Languages", "No data"),
        createDataLanguage("Southeast Asian Languages", "No data"),
        createDataLanguage("Eastern Asian Languages", "No data"),
        createDataLanguage("Australian Indigenous Languages", "No data"),
        createDataLanguage("Other Languages", "No data"),
        createDataLanguage("Supplementary codes", "No data"),
        createDataLanguage("Not stated", "No data"),
      ];
    } else {
      rowsLanguage = [
        createDataLanguage(
          "Northern European Languages",
          (
            Math.round(language.northern_european_languages * 100) / 100
          ).toFixed(2) + "%"
        ),
        createDataLanguage(
          "Southern European Languages",
          (
            Math.round(language.southern_european_languages * 100) / 100
          ).toFixed(2) + "%"
        ),
        createDataLanguage(
          "Eastern European Languages",
          (Math.round(language.eastern_european_languages * 100) / 100).toFixed(
            2
          ) + "%"
        ),
        createDataLanguage(
          "Southwest and Central Asian Languages",
          (
            Math.round(language.southwest_and_central_asian_languages * 100) /
            100
          ).toFixed(2) + "%"
        ),
        createDataLanguage(
          "Southern Asian Languages",
          (Math.round(language.southern_asian_languages * 100) / 100).toFixed(
            2
          ) + "%"
        ),
        createDataLanguage(
          "Southeast Asian Languages",
          (Math.round(language.southeast_asian_languages * 100) / 100).toFixed(
            2
          ) + "%"
        ),
        createDataLanguage(
          "Eastern Asian Languages",
          (Math.round(language.eastern_asian_languages * 100) / 100).toFixed(
            2
          ) + "%"
        ),
        createDataLanguage(
          "Australian Indigenous Languages",
          (
            Math.round(language.australian_indigenous_languages * 100) / 100
          ).toFixed(2) + "%"
        ),
        createDataLanguage(
          "Other Languages",
          (Math.round(language.other_languages * 100) / 100).toFixed(2) + "%"
        ),
        createDataLanguage(
          "Supplementary codes",
          (Math.round(language.supplementary_codes * 100) / 100).toFixed(2) +
            "%"
        ),
        createDataLanguage(
          "Not stated",
          (Math.round(language.not_stated * 100) / 100).toFixed(2) + "%"
        ),
      ];
    }
  }

  // const handleRefreshClick = () => {
  //   window.location.reload();
  // };

  if (dataFlag) {
    return (
      <React.Fragment>
        <Head>
          <title>
            Investing in {data.suburb_name}: Discover Growth and Yield Trends
          </title>
          <link rel="canonical" href={canonical}></link>
          <meta name="description" content={description} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"
          />
        </Head>
        {loading ? (
          <Box
            sx={{
              width: "100%",
              height: "300px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              sx={{ color: "var(--primary-color)" }}
              size={70}
            />
          </Box>
        ) : (
          <Container sx={{ flexGrow: 12, mt: 5 }}>
            {registerFlag ? (
              <div></div>
            ) : (
              <Box sx={{ width: "100%" }}>
                {/* {cookies.initialPath && cookies.access_token ? (
                  <Dialog open={true} fullWidth={true}>
                    <DialogTitle
                      id="responsive-dialog-title"
                      sx={{ textAlign: "center" }}
                    >
                      <br></br>
                      <h3>You are logged in</h3>
                    </DialogTitle>
                    <DialogContent>
                      <Container
                        sx={{ display: "flex", flexDirection: "column", mt: 3 }}
                      >
                        <Typography variant="h6" sx={{ textAlign: "center" }}>
                          Please refresh the page to see the data
                        </Typography>
                        <br></br>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 2,
                          }}
                        >
                          <SubmitBtn
                            sx={{
                              textTransform: "none",
                              width: "300px",
                              height: "50px",
                              fontSize: "20px",
                            }}
                            onClick={handleRefreshClick}
                          >
                            refresh
                          </SubmitBtn>
                        </Box>
                      </Container>
                    </DialogContent>
                  </Dialog>
                ) : null} */}

                <Collapse in={open}>
                  <Alert
                    severity="info"
                    icon={false}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        sx={{ color: "#fff" }}
                        onClick={() => {
                          setOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{
                      mb: 3,
                      background: "var(--dark-color)",
                      color: "#fff",
                      flexDirection: "column-reverse",
                    }}
                  >
                    <Item
                      variant="outlined"
                      sx={(theme) => ({
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        background: "none",
                        border: "none",
                        [theme.breakpoints.down("sm")]: {
                          flexDirection: "column",
                          width: "100%",
                        },
                      })}
                    >
                      <Item
                        variant="outlined"
                        sx={(theme) => ({
                          width: "48%",
                          height: "auto",
                          mr: 2,
                          mt: 1,
                          mb: 1,
                          background: "none",
                          border: "none",
                          [theme.breakpoints.down("md")]: {
                            width: "100%",
                            height: "auto",
                          },
                        })}
                      >
                        <CardContent
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Image
                            src={abode}
                            style={{ width: "40%", height: "auto" }}
                            alt="House"
                          />
                        </CardContent>
                      </Item>
                      <Item
                        variant="outlined"
                        sx={(theme) => ({
                          width: "48%",
                          height: "250px",
                          mr: 2,
                          mt: 1,
                          mb: 1,
                          background: "none",
                          border: "none",
                          [theme.breakpoints.down("md")]: {
                            width: "100%",
                            height: "auto",
                          },
                        })}
                      >
                        <CardContent
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ textAlign: "left", mt: 1, color: "#fff" }}
                          >
                            Welcome to Suburb Insight! To access valuable data
                            about different suburbs, please log in to your
                            account. If you're new here, creating an account is
                            quick and easy. Logging in allows us to personalise
                            your experience and provide you with exclusive
                            information about the suburbs you're interested in.
                            Thank you!
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mt: 3,
                            }}
                          >
                            <RegisterButton onClick={registerRedirect}>
                              Register
                            </RegisterButton>
                            <DismisButton onClick={loginRedirect}>
                              Login
                            </DismisButton>
                          </Box>
                        </CardContent>
                      </Item>
                    </Item>
                  </Alert>
                </Collapse>
              </Box>
            )}
            {limitFlag ? (
              <div></div>
            ) : (
              <Dialog
                open={openDialog}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle
                  id="alert-dialog-title"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  Rate Limit Exceeded
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenDialog(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Discovering the perfect suburb takes time. You've hit the
                    daily limit for Suburb Insight access. No worries, though!
                    Our expert consultants are eager to assist you personally.
                    <Button onClick={handleOpenBook}>Book a meeting</Button>now
                    and gain valuable insights tailored to your needs. Schedule
                    your session today!
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
            )}
            <Dialog
              open={bookNow}
              keepMounted
              onClose={handleCloseBook}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                <IconButton
                  aria-label="close"
                  onClick={handleCloseBook}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent
                sx={(theme) => ({
                  width: "600px",
                  textAlign: "center",
                  p: 4,
                  [theme.breakpoints.down("sm")]: { width: "280px" },
                })}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "20px", fontWeight: "600", mt: 3 }}
                  gutterBottom
                >
                  One of our partner consultants contacts you to schedule a
                  meeting.
                </Typography>
              </DialogContent>
            </Dialog>
            <Typography
              variant="h1"
              sx={{ fontSize: 35, fontWeight: 600, textAlign: "center", mb: 2 }}
            >
              Maximise Your Property Investment in {data.suburb_name} with
              Suburb Insight
            </Typography>
            <Typography
              variant="h2"
              gutterBottom
              sx={{ fontSize: 25, textAlign: "center", mb: 2 }}
            >
              Access Comprehensive Data and Informative Demographic Information
              to Inform Your Investment Strategy in {data.suburb_name}
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ fontSize: 20, textAlign: "center", mb: 2 }}
            >
              Get valuable insights into {data.suburb_name} property market with
              our Suburb Insight tool. Analyze key trends including growth
              rates, yields, and rental returns with easy-to-read infographics.
            </Typography>
            <Item variant="outlined" sx={{ width: "100%", mt: 5, mb: 2 }}>
              <Box sx={{ p: 3, py: 1.5 }}>
                <Typography variant="h3" sx={{ fontSize: 20, fontWeight: 600 }}>
                  House
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={(theme) => ({
                  px: 3,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  [theme.breakpoints.down("sm")]: { flexDirection: "column" },
                })}
              >
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Average annual growth
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {houseData == null
                        ? "No data"
                        : (
                            Math.round(houseData.average_annual_growth * 100) /
                            100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Quarterly growth
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {houseData == null
                        ? "No data"
                        : (
                            Math.round(houseData.quarterly_growth * 100) / 100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Gross rental yield
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {houseData == null
                        ? "No data"
                        : (
                            Math.round(houseData.gross_rental_yield * 100) / 100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
              </Box>
              <Box
                sx={(theme) => ({
                  width: "100%",
                  p: 5,
                  [theme.breakpoints.down("sm")]: { width: "100%", p: 1 },
                })}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: 18,
                    fontWeight: 400,
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  median sold price
                  <br></br>
                  <br></br>
                  {houseHistory == null ? (
                    <p style={{ color: "var(--dark-color)" }}>No data</p>
                  ) : (
                    <p></p>
                  )}
                </Typography>
                {registerFlag == false || limitFlag == false ? (
                  <div className={home.exampleAll}>
                    <div className={home.examplechart}></div>
                    <div className={home.exampleTextBox}>
                      <Typography variant="body1">
                        To access valuable data about different suburbs, please
                        log in to your account.
                      </Typography>
                    </div>
                    <div className={home.exampleOnly}>Example Only</div>
                  </div>
                ) : (
                  <DataChart history={houseHistory} />
                )}
              </Box>
            </Item>
            <CallToAction />
            <Item variant="outlined" sx={{ width: "100%", mt: 1, mb: 2 }}>
              <Box sx={{ p: 3, py: 1.5 }}>
                <Typography variant="h3" sx={{ fontSize: 20, fontWeight: 600 }}>
                  Unit
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={(theme) => ({
                  px: 3,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  [theme.breakpoints.down("sm")]: { flexDirection: "column" },
                })}
              >
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Average annual growth
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {unitData == null
                        ? "No data"
                        : (
                            Math.round(unitData.average_annual_growth * 100) /
                            100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Quarterly growth
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {unitData == null
                        ? "No data"
                        : (
                            Math.round(unitData.quarterly_growth * 100) / 100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "30%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Gross rental yield
                  </Typography>
                  {registerFlag == false || limitFlag == false ? (
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 %
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {unitData == null
                        ? "No data"
                        : (
                            Math.round(unitData.gross_rental_yield * 100) / 100
                          ).toFixed(2) + " %"}
                    </Typography>
                  )}
                </Item>
              </Box>
              <Box
                sx={(theme) => ({
                  width: "100%",
                  p: 5,
                  [theme.breakpoints.down("sm")]: { width: "100%" },
                })}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: 18,
                    fontWeight: 400,
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  median sold price
                  <br></br>
                  <br></br>
                  {unitHistory == null ? (
                    <p style={{ color: "var(--dark-color)" }}>No data</p>
                  ) : (
                    <p></p>
                  )}
                </Typography>
                {registerFlag == false || limitFlag == false ? (
                  <div className={home.exampleAll}>
                    <div className={home.examplechart}></div>
                    <div className={home.exampleTextBox}>
                      <Typography variant="body1">
                        To access valuable data about different suburbs, please
                        log in to your account.
                      </Typography>
                    </div>
                    <div className={home.exampleOnly}>Example Only</div>
                  </div>
                ) : (
                  <DataChart history={unitHistory} />
                )}
              </Box>
            </Item>
            <Item variant="outlined" sx={{ width: "100%", mt: 1, mb: 5 }}>
              <Box sx={{ p: 3, py: 1.5 }}>
                <Typography variant="h3" sx={{ fontSize: 20, fontWeight: 600 }}>
                  Suburb info
                </Typography>
              </Box>
              <Divider />
              <Box
                sx={(theme) => ({
                  px: 3,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: { flexDirection: "column" },
                })}
              >
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "34.5%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Distance from CBD
                  </Typography>
                  {registerFlag == true && limitFlag == false ? ( //&&
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0.0 km
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {data.distance == null
                        ? "No data"
                        : data.distance + " km"}
                    </Typography>
                  )}
                </Item>
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "33%",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Public Transport
                  </Typography>
                  {registerFlag == true && limitFlag == false ? ( //&&
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      AbodeFinder, AbodeFinder, AbodeFinder
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {transportation == null
                        ? "No data"
                        : transportation.join(", ")}
                    </Typography>
                  )}
                </Item>

                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "80%",
                    height: "109px",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Population
                  </Typography>
                  {registerFlag == true && limitFlag == false ? ( //&&
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      0,000
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600, mb: 4 }}
                    >
                      {data.population == null ? "No data" : data.population}
                    </Typography>
                  )}
                </Item>
              </Box>
              <Box
                sx={(theme) => ({
                  px: 3,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  [theme.breakpoints.down("sm")]: { flexDirection: "column" },
                })}
              >
                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "23%",
                    height: "200px",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    Average Age
                  </Typography>
                  {registerFlag == true && limitFlag == false ? ( //&&
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      00 to 00
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {data.average_age == null ? "No data" : data.average_age}
                    </Typography>
                  )}
                </Item>

                <Item
                  variant="outlined"
                  sx={(theme) => ({
                    width: "75%",
                    height: "200px",
                    m: 1,
                    p: 3,
                    [theme.breakpoints.down("sm")]: { width: "100%" },
                  })}
                >
                  <Typography variant="body2" gutterBottom>
                    School
                  </Typography>
                  {registerFlag == true && limitFlag == false ? ( //&&
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: 30,
                        fontWeight: 600,
                        filter: "blur(5px)",
                      }}
                    >
                      AbodeFinder, AbodeFinder, AbodeFinder, AbodeFinder
                    </Typography>
                  ) : (
                    <Typography
                      variant="h3"
                      sx={{ fontSize: 30, fontWeight: 600 }}
                    >
                      {school == null ? "No data" : school.join(", ")}
                    </Typography>
                  )}
                </Item>
              </Box>
            </Item>
            <Box className="mapStyle">
              <GoogleMaps
                suburb={data.suburb_name}
                state={data.state}
                postcode={data.postcode}
              />
            </Box>

            <Item variant="outlined" sx={{ width: "100%", mt: 5, mb: 5 }}>
              <SuburbChart
                data={data}
                incomeData={rows}
                languageData={language}
              />
            </Item>

            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "center",
                [theme.breakpoints.down("sm")]: { flexDirection: "column" },
              })}
            ></Box>

            <Item
              variant="outlined"
              sx={(theme) => ({
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "center",
                p: 2,
                mb: 5,
                [theme.breakpoints.down("sm")]: {
                  flexDirection: "column",
                  width: "100%",
                },
              })}
            >
              <Item
                variant="outlined"
                sx={(theme) => ({
                  width: "48%",
                  height: "310px",
                  mr: 2,
                  mt: 1,
                  mb: 1,
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                    height: "auto",
                  },
                })}
              >
                <CardContent
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    sx={{
                      width: 75,
                      height: 75,
                      backgroundColor: "var(--primary-color)",
                    }}
                  >
                    <WhereToVoteIcon sx={{ fontSize: "50px" }} />
                  </Avatar>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "center", mt: 3 }}
                  >
                    Find the perfect suburb for your next property investment
                    with SuburbFinder. Get customised recommendations based on
                    your budget, public transport needs, and school preferences.
                  </Typography>
                  <SelectButton href="/suburb-finder/">
                    Find Your Perfect Suburb Now
                  </SelectButton>
                </CardContent>
              </Item>
              <Item
                variant="outlined"
                sx={(theme) => ({
                  width: "48%",
                  height: "310px",
                  mr: 2,
                  mt: 1,
                  mb: 1,
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                    height: "auto",
                  },
                })}
              >
                <CardContent
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    sx={{
                      width: 75,
                      height: 75,
                      backgroundColor: "var(--primary-color)",
                    }}
                  >
                    <QueryStatsIcon sx={{ fontSize: "50px" }} />
                  </Avatar>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "center", mt: 3 }}
                  >
                    Calculate your chances of buying the perfect property with
                    our AI-powered Buying Chance Calculator. Get personalized
                    insights based on your budget and selected suburbs.
                  </Typography>
                  <SelectButton href="/buying-chance/">
                    Get Personalised Buying Insights Now
                  </SelectButton>
                </CardContent>
              </Item>
            </Item>
            <Card
              variant="outlined"
              sx={{
                border: "3px solid var(--primary-color)",
                p: 5,
                mb: 5,
                borderRadius: "15px",
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontSize: "24px", fontWeight: "600", mb: 3 }}
              >
                Are you considering investing in the {data.suburb_name}-
                {data?.state?.toUpperCase()} property market?
              </Typography>
              <Typography variant="body1">
                AbodeFinder's Suburb Insight tool can help you make informed
                investment decisions by providing comprehensive data and
                informative demographic information about this suburb.
              </Typography>
              <Typography variant="body1">
                With our easy-to-read infographics, you can analyse key trends
                in the {data.suburb_name} property market, including growth
                rates, rental returns, and yields. You can also explore the
                suburb's demographic data, such as population growth, age
                distribution, and median income, to inform your investment
                strategy.
              </Typography>
              <Typography variant="body1">
                Using Suburb Insight, you can discover investment opportunities
                in {data.suburb_name} that align with your budget, preferred
                state, public transport needs, and school type. Our
                user-friendly and intuitive platform makes it easy to find your
                dream home and make informed decisions about your property
                investment.
              </Typography>
              <Typography variant="body1">
                But don't just stop there. Schedule a meeting with one of our
                expert property consultants to get a deeper understanding of{" "}
                {data.suburb_name}'s property market and how you can maximise
                your investment. Our consultants have years of experience in the
                industry and can offer valuable insights into the local market.
                Book a consultation today and take the first step towards
                securing your financial future with AbodeFinder.
              </Typography>
              <Typography variant="body1">
                At AbodeFinder, we are committed to being your ultimate partner
                in your property investment journey. Trust us to provide you
                with the insights and tools you need to maximise your property
                investment in {data.suburb_name}. Start using Suburb Insight
                today and take the first step towards securing your financial
                future.
              </Typography>
            </Card>
            <Grid container spacing={1}>
              <React.Fragment>
                <Grid item xs={12} md={12} columns={{ xs: 12 }} ref={scroll}>
                  {agents.map((agent) => (
                    <AgentCard
                      firstname={agent.firstname}
                      lastname={agent.lastname}
                      email={agent.email}
                      mobile={agent.mobile}
                      id={agent.id}
                      photo={agent.photo}
                      total_purchased={agent.total_purchased}
                      total_purchased_12_month={agent.total_purchased_12_month}
                      total_purchased_12_month_value={
                        agent.total_purchased_12_month_value
                      }
                      total_purchased_value={agent.total_purchased_value}
                      fees={agent.fees}
                      areas={agent.areas}
                      qualifications={agent.qualifications}
                      stars={agent.stars}
                      stars_reviews={agent.stars_reviews}
                    />
                  ))}
                </Grid>
              </React.Fragment>
            </Grid>
            <CallToActioTwo />
          </Container>
        )}
        <Footer />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Head>
          <title>404</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"
          />
        </Head>
        <Custom404 />
      </React.Fragment>
    );
  }
}

export async function getServerSideProps(context) {
  const cookies = context.req.headers.cookie;
  const { state, suburb } = context.params;
  const match = suburb.match(/^(.+)-(\d+)$/);
  const suburbName = match[1].replace(/-/g, "");
  const suburbPostcode = match[2];

  const access_token = context.req.cookies.access_token;
  const login = context.req.cookies.login;
  //   const access_token = context.req.cookies["access_token"];
  try {
    if (access_token) {
      const response = await fetch(
        `https://abodefinder.com.au/api/profile/${state}/${suburbName}-${suburbPostcode}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const suburb_name = data.suburb_name;
        console.log("suburb_name", suburb_name);
        console.log("state", state);

        const description = `Explore ${data.suburb_name} with Suburb Insight - Find growth and rental yield data for houses and apartments, plus informative demographic insights on Australia's top suburbs.`;
        const canonical = `https://abodefinder.com.au/suburb/${state}/${suburb}/`;
        return {
          props: {
            data: data,
            loading: false,
            suburb_name: suburb_name,
            description: description,
            canonical: canonical,
            registerFlag: true,
            limitFlag: true,
            houseData: data.house_data,
            unitData: data.unit_data,
            transportation: data.transportation,
            school: data.school,
            income: data.income,
            language: data.languages,
            houseHistory: data.house_history,
            unitHistory: data.unit_history,
            stateName: data.state,
            access_token: access_token,
            login: login,
          },
        };
      } else {
        const errorCode = response.status;
        let errorMessage = "An error occurred";

        if (errorCode === 404) {
          errorMessage = "Not Found";
        } else if (errorCode === 403) {
          return {
            props: {
              data: [],
              loading: false,
              registerFlag: true,
              limitFlag: true,
            },
          };
        } else if (errorCode === 429) {
          return {
            props: {
              data: [],
              suburb_name: "No Data",
              description: "No Data",
              canonical: "",
              loading: false,
              registerFlag: true, //// means registered
              limitFlag: false, // means limited
              houseData: {},
              unitData: {},
              transportation: [],
              school: [],
              income: {},
              language: {},
              houseHistory: [],
              unitHistory: [],
              stateName: "No Data",
              access_token: access_token,
            },
          };
        }
        return {
          props: {
            data: [],
            loading: false,
            errorCode: errorCode,
            registerFlag: true,
            limitFlag: true,
            houseData: {},
            unitData: {},
            transportation: [],
            school: [],
            income: {},
            language: {},
            houseHistory: [],
            unitHistory: [],
            errorCode: errorCode,
            errorMessage: errorMessage,
          },
        };
      }
    } else {
      const response = await fetch(
        `https://abodefinder.com.au/api/profile/${state}/${suburbName}-${suburbPostcode}/no-auth/`,
        {
          headers: {
            accept: "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const suburb_name = data.suburb_name;
        const description = `Explore ${data.suburb_name} with Suburb Insight - Find growth and rental yield data for houses and apartments, plus informative demographic insights on Australia's top suburbs.`;
        const lowercaseSuburb = data.suburb_name.toLowerCase();
        const hyphenatedSuburb = lowercaseSuburb.replace(/\s+/g, "-");
        const canonical = `https://abodefinder.com.au/suburb/${data.state}/${hyphenatedSuburb}-${data.postcode}/`;

        return {
          props: {
            data: data,
            loading: false,
            suburb_name: suburb_name,
            description: description,
            canonical: canonical,
            registerFlag: false, // means not registered
            limitFlag: true, // means not limited
            houseData: {},
            unitData: {},
            transportation: data.transportation,
            school: data.school,
            income: data.income,
            language: data.languages,
            houseHistory: [],
            unitHistory: [],
            stateName: "No Data",
          },
        };
      } else {
        return {
          props: {
            data: null,
            loading: false,
          },
        };
      }
    }
  } catch (error) {
    return {
      props: {
        data: [],
        loading: false,
        limitFlag: true, // means not limited
        houseData: {},
        unitData: {},
        transportation: [],
        school: [],
        income: {},
        language: {},
        houseHistory: [],
        unitHistory: [],
        stateName: "No Data",
      },
    };
  }
}
